module.exports = __webpack_public_path__ + "static/media/offering-image-three.6a1d5720.png";